var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo = function SvgLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 341.11 290.24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#231f20;stroke-miterlimit:10;stroke-width:8px;}.cls-2{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.21,242.47s-92.33,10.46-104.48-7.18C7.2,224.36,72.9,224.18,72.9,224.18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.72,138.1C39,129.87,11,138.13,6.58,158s-8.9,40.52,39.29,74.2S193,291.56,261.53,231.1c67.75-59.79,27.87-137.89,32.39-159.33S336,17.2,337.08,8s-22.14-.13-28.82,4.07-33.53,24.36-33.53,24.36-22.64-8.84-34-1.25S221.8,45.69,220.37,50s41.19,17.41,43,34.23,2,55-43.06,83.71C137.62,220.63,74,152.53,51.72,138.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.82,248.41c11.55,5.77,43.55,39.35,57.19,37.77s16.79-29.38,5.25-37.77-16.79-13.12-16.79-13.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.84,176.77s-3.76,3.95.76,5.46,5.46-2.08,5.46-2.08a3.85,3.85,0,0,1-4.52.38A3.29,3.29,0,0,1,89.84,176.77Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.06de13212d41ee95b2a464381fd77f3f.svg";